import {JsonApiService} from './api'

class RiskApi extends JsonApiService {
  constructor () {
    super('risk')
  }
}

export {RiskApi}
